export default __webpack_public_path__ + "static/media/Emotions_06.d7b9505f.png";